import { CourseType } from '../constants/courseEnums';
import type { Course, CoursesResponse } from '../api/types';

type CourseGroupsData = CoursesResponse['data'];

export const COURSE_GROUPS: { type: CourseType; key: keyof CourseGroupsData }[] = [
  { type: CourseType.MASTERS_DEGREE, key: 'mastersDegreeCourses' },
  { type: CourseType.PRE_MASTERS_DEGREE, key: 'preMastersDegreeCourses' },
  { type: CourseType.BACHELORS_DEGREE, key: 'bachelorsDegreeCourses' },
  { type: CourseType.OTHM, key: 'othmCourses' },
  { type: CourseType.SHORT, key: 'shortCourses' },
];

export const getCourseGroup = (
  data: CourseGroupsData | undefined | null,
  type: CourseType,
): Course[] => {
  const group = COURSE_GROUPS.find((item) => item.type === type);
  const courses = group && data ? data[group.key] : undefined;
  return Array.isArray(courses) ? courses : [];
};

export const flattenCourseGroups = (data?: CourseGroupsData | null): Course[] =>
  COURSE_GROUPS.flatMap(({ type }) => getCourseGroup(data, type));

export const getCourseGroupType = (
  data: CourseGroupsData | undefined | null,
  courseId: number,
): CourseType | null =>
  COURSE_GROUPS.find(({ type }) =>
    getCourseGroup(data, type).some((course) => course.id === courseId),
  )?.type ?? null;
